import styled from 'styled-components';

export const MainContainer = styled.div<{ maxBlockHeight: number }>`
  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    max-height: ${({ maxBlockHeight }) => `${maxBlockHeight}px`};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0 20px;

    label {
      width: 274px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    gap: 0 5px;
    label {
      width: 254px;
    }
  }
`;
